import { useCallback, useReducer } from 'react';
import { useShowToast } from './useShowToast';
import { useBlock } from './TRPC_Hooks/useBlock';
interface IUnblockState {
  isUnblockModalVisible: boolean;
  isSuccessModalVisible: boolean;
}
type UnblockAction = {
  type: 'SHOW_UNBLOCK_MODAL';
} | {
  type: 'SHOW_SUCCESS_MODAL';
} | {
  type: 'SET_STATE';
  payload: IUnblockState;
} | {
  type: 'COMPLETE';
};
interface IUseUnblockFlowProps {
  targetShortId: string;
  onComplete?: () => void;
  onClose?: () => void;
}
const initialState: IUnblockState = {
  isUnblockModalVisible: true,
  isSuccessModalVisible: false
};
function unblockReducer(state: IUnblockState, action: UnblockAction): IUnblockState {
  switch (action.type) {
    case 'SHOW_UNBLOCK_MODAL':
      return {
        ...state,
        isSuccessModalVisible: false,
        isUnblockModalVisible: true
      };
    case 'SHOW_SUCCESS_MODAL':
      return {
        ...state,
        isUnblockModalVisible: false,
        isSuccessModalVisible: true
      };
    case 'COMPLETE':
      return {
        ...initialState
      };
    default:
      return state;
  }
}
export const useUnblockFlow = ({
  onClose,
  targetShortId
}: IUseUnblockFlowProps) => {
  const [state, dispatch] = useReducer(unblockReducer, initialState);
  const {
    showToast
  } = useShowToast();
  const {
    unblockUser
  } = useBlock();
  const hideModals = useCallback(() => {
    onClose?.();
  }, [onClose]);
  const showSuccessModal = useCallback(() => {
    dispatch({
      type: 'SHOW_SUCCESS_MODAL'
    });
  }, []);
  const handleUnblock = useCallback(async () => {
    try {
      await unblockUser({
        targetShortId: targetShortId
      });
      hideModals();
    } catch (error) {
      showToast({
        variant: 'error',
        text: 'error.default'
      });
    }
  }, [targetShortId, showToast, unblockUser, hideModals]);
  return {
    ...state,
    hideModals,
    handleUnblock,
    showSuccessModal
  };
};